import type { itemState } from './types';

export default function getItemState(locked: boolean, isSelected: boolean): itemState {
    if (locked) return 'locked';
    if (isSelected) return 'chosen';
    return 'choose';
}
